<template>
  <div class="num_all">

    <el-row >
      <el-col :span="18" :justify="end" ><div class="grid-content num_r">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item  v-for="item in numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
        </el-menu>
                </div></el-col>
              </el-row>
            </div>
          </template>
<style>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}

</style>
          <script>
          export default {
            name: "mun2",
            data() {
              return {
                numList : [
                  {
                    num : 1,
                    tital : "产品介绍",
                    path: "aa"
                  },
                  {
                    num : 2,
                    tital : "工作尖",
                    path: "aa"
                  },
                  {
                    num : 3,
                    tital : "手柄",
                    path: "aa"
                  }
                  ]
              }
            }
          }
          </script>

          <style scoped>

          </style>



// WEBPACK FOOTER //
// src/components/image/mun2.vue